"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var useI18n_1 = __importDefault(require("@paprika/l10n/lib/useI18n"));
var NavigationButton_1 = __importDefault(require("../NavigationButton/NavigationButton"));
var constants_1 = require("../../constants");
var SignIn_styles_1 = __importDefault(require("./SignIn.styles"));
function SignIn(_a) {
    var loginUrl = _a.loginUrl, zIndex = _a.zIndex;
    var i18n = useI18n_1.default();
    function handleClickLogin() {
        window.location.href = loginUrl;
    }
    return (react_1.default.createElement(SignIn_styles_1.default, { "data-sri-anchor": "navigation-signin" },
        react_1.default.createElement(NavigationButton_1.default, { ariaLabel: i18n.t('global_navigation.navigation_items.sign_in'), onClick: handleClickLogin, zIndex: zIndex }, i18n.t('global_navigation.navigation_items.sign_in'))));
}
SignIn.propTypes = {
    loginUrl: prop_types_1.default.string.isRequired,
    zIndex: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
};
SignIn.defaultProps = {
    zIndex: null,
};
SignIn.componentType = constants_1.navigationItems.signIn;
exports.default = SignIn;
//# sourceMappingURL=SignIn.js.map